import Typography from "components/basic/typography";

interface FieldContainerProps {
  title: string;
  children: JSX.Element | JSX.Element[];
  noGap?: boolean;
  style?: React.CSSProperties;
  marginLeft?: number;
}

const FieldContainer: React.FC<FieldContainerProps> = ({
  title,
  children,
  noGap = false,
  style,
  marginLeft = 0,
}) => {
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        gap: noGap ? "0px" : "10px",
        padding: "10px 0",
        width: "100%",
        marginLeft: marginLeft,
      }}
    >
      <Typography variant="h4" align="left">
        {title}
      </Typography>

      <div style={style}>{children}</div>
    </div>
  );
};

export default FieldContainer;
